import React from 'react';

import {
    Flex,
    Image,
    Spacer,
} from '@zillow/constellation';

import { StyledCenterText } from 'app/shared/StyledComponents/StyledComponents';

import Trophy from 'app/shared/images/Trophy.svg';

import { StyledDialogBodyContainer } from 'app/shared/containers/ModalContainer/StyledComponents';

import { StyledIconContainer } from './StyledComponents';

const propTypes = {};

const defaultProps = {};

const FeedListingDeactivateConfirmationThanksModal = () => (
    <StyledDialogBodyContainer className="FeedListingDeactivateConfirmationThanksModal">
        <Flex
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
        >
            <Spacer marginY="xs">
                <StyledIconContainer>
                    <Image src={Trophy} alt="trophy" />
                </StyledIconContainer>
            </Spacer>

            <StyledCenterText as="p" fontType="body">
                This listing will be deactivated as of today.
            </StyledCenterText>

            <Spacer paddingBottom="xs" />

            <StyledCenterText as="p" fontType="body">
                Your advertising period will be included on your next invoice.
            </StyledCenterText>
            <Spacer paddingBottom="sm" />
        </Flex>
    </StyledDialogBodyContainer>
);

FeedListingDeactivateConfirmationThanksModal.propTypes = propTypes;
FeedListingDeactivateConfirmationThanksModal.defaultProps = defaultProps;

export default FeedListingDeactivateConfirmationThanksModal;
